import { Routes, Route, Navigate } from "react-router-dom";
import {
  ROUTE_VOCABULARY,
  ROUTE_GRAMMAR,
  ROUTE_CONVERSATION,
  ROUTE_WRITING,
  ROUTE_READING,
  ROUTE_SPOKEN,
  ROUTE_EXAMS,
  ROUTE_DASHBOARD,
  ROUTE_PROFILE
} from "../communicative.js";
import { Vocabulary } from "../../communicative-english/vocabulary";
import { Grammar } from "../../communicative-english/grammar";
import Conversation from "../../communicative-english/conversation-practice";
import WritingPractice from "../../communicative-english/writing-practice";
import { ReadingPractice } from "../../communicative-english/reading-practice/index.jsx";
import { SpokenPractice } from "../../communicative-english/spoken-practice";
import Dashboard from "../../communicative-english/dashboard"
import { Profile } from "../../communicative-english/profile";
import { CompetitiveExam } from "../../communicative-english/competitive-exam/index.jsx";

export const CommunicativeRoutes = () => {
  return (
    <Routes>
      <Route path={ROUTE_DASHBOARD} element={<Dashboard />} />
      <Route path={ROUTE_VOCABULARY} element={<Vocabulary />} />
      <Route path={ROUTE_GRAMMAR} element={<Grammar />} />
      <Route path={ROUTE_CONVERSATION} element={<Conversation />} />
      <Route path={ROUTE_READING} element={<ReadingPractice />} />
      <Route path={ROUTE_WRITING} element={<WritingPractice />} />
      <Route path={ROUTE_SPOKEN} element={<SpokenPractice />} />
      <Route path={ROUTE_EXAMS} element={<CompetitiveExam />} />
      <Route path={ROUTE_PROFILE} element={<Profile />} />
    </Routes>
  );
};
